/** Inline trend for category rows. Height comes from chart.sparklineHeight. */
import { chart } from '@/lib/tokens'
import { t } from '@/lib/copy'

export function Sparkline({
  values,
  label,
  color = 'var(--color-textTertiary)',
  width = 72,
}: {
  values: number[]
  label: string
  color?: string
  width?: number
}) {
  const height = chart.sparklineHeight
  if (values.length < 2) return <span style={{ width, height, display: 'inline-block' }} aria-hidden="true" />

  const max = Math.max(...values)
  const min = Math.min(...values)
  const span = max - min || 1
  const step = width / (values.length - 1)
  const path = values
    .map((value, i) => `${i === 0 ? 'M' : 'L'}${(i * step).toFixed(1)},${(height - ((value - min) / span) * height).toFixed(1)}`)
    .join(' ')

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={t('a11y.sparkline', { label, count: values.length })}
      style={{ overflow: 'visible', flex: 'none' }}
    >
      <path d={path} fill="none" stroke={color} strokeWidth={chart.lineWidth} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  )
}
